import { Topbar } from '@/components/organisms/Topbar';
import { Skeleton } from '@/components/ui/skeleton';
import { ActivitySkeletonRow } from '@/components/organisms/ActivityRow';

/**
 * `/notifications` route pending state: Topbar + a filter-bar skeleton + 4×
 * the existing `ActivitySkeletonRow` — reused, not reinvented.
 */
export function NotificationsPendingState() {
  return (
    <>
      <Topbar crumbs={[{ label: 'Account' }, { label: 'Notifications' }]} title="Notifications" />

      <div
        className="flex min-h-0 flex-1 flex-col overflow-auto"
        style={{ background: 'var(--canvas)' }}
      >
        <div
          className="mx-auto flex w-full flex-col gap-5 px-4 py-6 md:px-8"
          aria-busy="true"
          aria-live="polite"
        >
          <Skeleton className="h-11 w-full rounded-md" />
          <div className="overflow-hidden rounded-2xl border border-border bg-card py-2">
            {Array.from({ length: 4 }, (_, i) => (
              <ActivitySkeletonRow key={i} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
